import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxCoolDialogsService } from 'ngx-cool-dialogs';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AlertsProvider } from 'src/app/providers/alerts/alerts.provider';
import { ToastProvider } from 'src/app/providers/toast/toast';
import { ModalService } from '../modal.service';
import { ApiService } from 'src/app/services/api/api.service';
import { EventsService } from 'src/app/services/events.service';
import { UtilitysService, HyperLinkService, StorageService } from 'src/app/services/utilitys/utilitys.service';
//import { UtilityService } from 'src/app/services/utilitys/utilitys.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-modal-friend',
  templateUrl: './modal-friend.component.html',
  styleUrls: ['./modal-friend.component.scss']
})
export class ModalFriendComponent implements OnInit {

  @ViewChild('friendModal', { static: false }) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg hastag-modal',
    ignoreBackdropClick: true,
    keyboard: false,
    animated: false
  };
  userQuestionUpdate = new Subject<string>();
  checkedItem: any;
  selectedItem: any = [];
  resovle: Function;
  qText: any;
  p = 1;
  pSize = 20;
  currentLimit: any;
  limit: any;
  empItems: any;
  dataLoaded = true;
  isSelected = false;
  multiple = true;
  userId: any;
  isReson = false;
  isIsConfirmed = false;
  reson: any = '';
  fromType: any;
  clientData: any;
  profile: any;
  shareLimited: any;
  isOverShareLimited = false;
  itemSelecteds = [];
  receiver: any;
  myTabStatus: number = 0;

  constructor(
    private ent: EventsService,
    private modalService: BsModalService,
    private api: ApiService,
    private toast: ToastProvider,
    private utility: UtilitysService,
    private myAlert: AlertsProvider,
    private modalServ: ModalService
  ) { }

  ngOnInit() {
    this.getProfileData();
    this.ent.onSelectFriendModalEvent.subscribe((data: any) => {
      this.clientData = data;
      if (data.resovle) {
        this.resovle = data.resovle;
      }

      this.multiple = false;
      if (data.multiple) {
        this.multiple = true;
      }

      this.selectedItem = [];
      if (data.selectedItem && data.selectedItem.length > 0) {
        this.selectedItem = data.selectedItem;
      }

      this.isOverShareLimited = false;
      this.shareLimited = data.shareLimited;

      this.isReson = data.isReson;
      this.fromType = data.fromType;
      this.reson = '';
      this.reson = data.reson;

      this.show();
    });

    this.userQuestionUpdate.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(value => {
      this.qText = value;
      this.p = 1;
      this.currentLimit = 0;
      this.getEmp();
    });
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.hide();
  }

  show() {
    this.empItems = [];
    this.dataLoaded = false;
    this.p = 1;
    this.currentLimit = 0;
    this.isIsConfirmed = false;
    this.qText = '';
    this.itemSelecteds = [];
    this.getEmp();
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    this.modalRef.hide();
  }

  setSelected(item: any) {
    this.selectedItem.forEach(x => {
      let usrIdA = x.UserID || x.UserId || x.Id;
      item.forEach(pilot => {
        let usrIdB = pilot.UserID || pilot.UserId || pilot.Id;
        if (usrIdA == usrIdB) {
          pilot.isSelected = true;
          this.isSelected = true;
        }
      });
    });

    return item;
  }

  getEmp() {
    this.dataLoaded = false;
    let sub = this.api.getSearchUserProfile(this.p, this.pSize, (`${this.qText || ''}`).toString().trim(), this.myTabStatus).subscribe((res: any) => {
      console.log(res);
      if (res.Code == 200) {
        res.Results = this.setSelected(res.Results || []);
        if (this.p == 1) {
          this.empItems = res.Results;
        } else {
          res.Results.forEach(element => {
            this.empItems.push(element);
          });
        }

        if (res.Results && res.Results.length > 0) {
          let id1 = null;
          this.itemSelecteds.forEach((x1, i) => {
            id1 = x1.UserID || x1.UserId || x1.Id;
            let id2 = null;
            this.empItems.forEach(x2 => {
              id2 = x2.UserID || x2.UserId || x2.Id;
              if (id1 == id2) {
                x2.isSelected = true;
              }
            });
          });

          this.p++;
          this.getProfileData();
        }

      } else {
        if (res.Code != 200) {
          this.toast.serviceError(res);
        }
      }
      this.dataLoaded = true;
      sub.unsubscribe();
    });
  }

  async onConfirm() {
    this.checkedItem = [];
    let friend = [];
    this.itemSelecteds.forEach(el => {
      this.checkedItem.push(el.UserID || el.UserId || el.Id);
      friend.push(el);
    });

    let data = {
      userIds: this.checkedItem,
      friend,
      reson: this.reson
    }

    if (this.fromType == 'SHARE_NEWS') {
      let msg = await this.utility.getText('WORKPLUS.EXP_PLUS.SHARE');
      this.myAlert.confirm(msg + '?').then(res => {
        if (res) {
          this.resovle(data);
          this.hide();
        }
      });
    } else if (this.fromType == 'SHARE_ACTIVITY') {
      let msg = await this.utility.getText('WORKPLUS.EXP_PLUS.SHARE');
      this.myAlert.confirm(msg + '?').then(res => {
        if (res) {
          this.resovle(data);
          this.hide();
        }
      });
    } else if (this.fromType == 'SHARE_EXP') {
      let msg = await this.utility.getText('WORKPLUS.EXP_PLUS.SHARE');
      this.myAlert.confirm(msg + '?').then(res => {
        if (res) {
          this.resovle(data);
          this.hide();
        }
      });
    } else if (this.fromType == 'TRANSTER_POINT') {
      this.resovle(data);
      this.hide();

      this.modalServ.onPointTransfer.emit({ receiver: this.receiver, myProfile: this.profile, userId: this.userId });
    } else if (this.fromType == 'EXP_POST') {
      this.resovle(data);
      this.hide();
    } else if (this.fromType == 'SEND_GIFT') {
      let msg = await this.utility.getText('WORKPLUS.EXP_PLUS.SHARE');
      this.myAlert.confirm(this.reson + '?').then(res => {
        if (res) {
          this.resovle(data);
          this.hide();
        }
      });
    } else {
      this.resovle(data);
      this.hide();
    }
  }

  next() {
    this.isIsConfirmed = true;
  }

  back() {
    this.isIsConfirmed = false;
  }

  onScrollFriendList(ev: any) {
    if ((ev.target.scrollHeight - ev.target.clientHeight) == ev.target.scrollTop && this.dataLoaded) {
      this.getEmp();
    }
  }

  clickChecked(item: any, check: any) {
    this.receiver = item;
    this.isSelected = false;
    if (!this.multiple) {
      this.itemSelecteds = [];
      this.empItems.forEach(el => {
        el.isSelected = false;
        let usrIdA = el.UserID || el.UserId || el.Id,
          usrIdB = item.UserID || item.UserId || item.Id;
        if (usrIdA == usrIdB) {
          el.isSelected = check.checked;
          this.isSelected = check.checked;

          if (el.isSelected) {
            this.itemSelecteds.push(el);
          } else {
            let id = null;
            this.itemSelecteds.forEach((val, i) => {
              id = val.UserID || val.UserId || val.Id;
              if (id == usrIdA) {
                this.itemSelecteds.splice(i, 1);
              }
            });
          }
        }
      });
    } else {

      this.empItems.forEach(el => {
        let usrIdA = el.UserID || el.UserId || el.Id,
          usrIdB = item.UserID || item.UserId || item.Id;
        if (usrIdA == usrIdB) {
          el.isSelected = check.checked;

          if (el.isSelected) {
            this.itemSelecteds.push(el);
          } else {
            let id = null;
            this.itemSelecteds.forEach((val, i) => {
              id = val.UserID || val.UserId || val.Id;
              if (id == usrIdA) {
                this.itemSelecteds.splice(i, 1);
              }
            });
          }
        }
      });

      this.setIsSelected(this.empItems);

      if (this.shareLimited) {
        this.isOverShareLimited = this.checkOverLimited();
      }
    }
  }

  checkOverLimited() {
    if (this.itemSelecteds.length == this.shareLimited) {
      //var ln = localStorage.getItem("language") ?? 'English';
      var ln = 'en';
      if (localStorage.getItem("language") != null && localStorage.getItem("language") != undefined) {
        ln = localStorage.getItem("language");
      }
      let msg = `You can share a maximum of ${this.shareLimited}.`
      if (ln == "th") {
        msg = `คุณสามารถแชร์ได้สูงสุด ${this.shareLimited}.`;
      }
      this.toast.toastWarning({ text: msg })
      return true;
    }

    return false;
  }

  setIsSelected(items: any) {
    var BreakException = {};
    try {
      items.forEach(el => {
        if (el.isSelected) {
          this.isSelected = true;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
  }

  async getProfileData() {
    this.profile = await this.getMyProfile();
    //this.userId = this.profile?.UserID || this.profile?.UserId || this.profile?.Id;
    this.userId = this.profile.UserID || this.profile.UserId || this.profile.Id;
  }

  getMyProfile(): Promise<any> {
    return new Promise((resovle: any) => {
      this.api.getMyProfile(this.api.token.toString()).subscribe((res: any) => {
        if (res.Code == 200) {
          resovle(res.Results);
        } else {
          this.toast.serviceError(res);
        }
        resovle(null);
      }, err => {
        this.toast.internalError();
        console.error(err);
        resovle(null);
      });
    });
  }
  onTab(type: any) {
    if (!this.dataLoaded) return;
    this.myTabStatus = type;
    this.p = 1;
    this.getEmp();
  }
  favorite(item: any) {
    var favoriteModel: any = {};
    favoriteModel.friendId = item.UserID;
    this.api.crateFavoriteFriend(favoriteModel).subscribe(res => {
      if (res.Code == 200) {
        item.IsFavoriteFriend = !item.IsFavoriteFriend;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }
}
